import { Billing, ChangePassword, EditProfile } from 'components/Profile';
import { useAuth } from 'contexts/auth';
import { useViewport } from 'contexts/viewport';
import ErrorPage from 'pages/Error/404';
import Desktop from 'pages/Profile/desktop';
import Mobile from 'pages/Profile/mobile';
import Tablet from 'pages/Profile/tablet';
import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { AlertDialog } from 'shell/components';

const ProfilePage = () => {
    const { currentUser } = useAuth();
    const history = useHistory();
    const params = useParams();
    const { device } = useViewport();

    const [onBeforeChange, setOnBeforeChange] = useState({ action: (proceed) => proceed() });
    const [selected, _setSelected] = useState(device === 'mobile' ? '' : 'edit-profile');
    const [alertDialog, setAlertDialog] = useState({
        open: false,
        message: '',
        description: '',
        note: '',
        variant: 'destructive',
        actionButtonText: 'Leave',
        cancelButtonText: 'Cancel',
        onAction: () => {},
        onCancel: () => setAlertDialog((current) => ({ ...current, open: false })),
        onClose: () => setAlertDialog((current) => ({ ...current, open: false })),
    });

    const setSelected = (selected) => {
        history.push(`/profile/${selected}`);
    };

    const getContent = (key) => {
        return {
            'edit-profile': (
                <EditProfile
                    setSelected={setSelected}
                    setAlertDialog={setAlertDialog}
                    setOnBeforeChange={setOnBeforeChange}
                />
            ),
            'change-password': <ChangePassword setSelected={setSelected} />,
            billing: <Billing setSelected={setSelected} />,
        }[key];
    };

    const panelList = {
        LTI: [{ key: 'edit-profile', value: 'Edit Profile', content: getContent('edit-profile') }],
        PASSWORD: [
            { key: 'edit-profile', value: 'Edit Profile', content: getContent('edit-profile') },
            { key: 'change-password', value: 'Change Password', content: getContent('change-password') },
            ...(currentUser.has_full_access
                ? []
                : [{ key: 'billing', value: 'Billing & Plans', content: getContent('billing') }]),
        ],
    };

    const props = {
        options: panelList[process.env.REACT_APP_AUTH],
        selected,
        onBeforeChange: onBeforeChange.action,
        onChange: setSelected,
    };

    const renderResponsiveLayout = (device) => {
        return {
            mobile: <Mobile {...props} />,
            tablet: <Tablet {...props} />,
            desktop: <Desktop {...props} />,
        }[device];
    };

    useEffect(() => {
        if (params.tab) {
            _setSelected(params.tab);
        }
    }, [params]);

    useEffect(() => {
        if ((device === 'tablet' || device === 'desktop') && !selected) {
            _setSelected('edit-profile');
        }
    }, [device, selected]);

    useEffect(() => {
        setOnBeforeChange({ action: (proceed) => proceed() });
    }, [selected]);

    if (!props.options.some(({ key }) => key === selected)) return <ErrorPage />;

    return (
        <>
            {renderResponsiveLayout(device)}
            <AlertDialog {...alertDialog} />
        </>
    );
};

export default ProfilePage;
